import React, { useState, useEffect } from "react";
import "./Page.css";
import "./PageOutro.css";
import useStore from "../store.js";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import Button from "../components/Button/Button.js";

const Page = (props) => {
  const getLocalized = useStore((state) => state.getLocalized);
  const game = useStore((state) => state.game);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const texts = useStore((state) => state.texts);

  useEffect(() => {
    // Fetch products from Shopify products.json endpoint
    const fetchProducts = async () => {
      try {
        const response = await fetch(
          "https://www.mitmach-krimi.de/collections/krimidinner-zuhause/products.json",
        );

        if (!response.ok) {
          throw new Error("Failed to fetch products");
        }

        const data = await response.json();
        setProducts(data.products || []);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching products:", err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  console.log("Bild", texts);

  if (!game) return null;

  return (
    <div
      className={`Page Outro${props.className ? " " + props.className : ""}`}
    >
      <h1>{getLocalized("texts", "Ende")}</h1>
      <BlocksRenderer content={getLocalized("texts", "SpielendeText")} />
      {getLocalized("texts", "SpielendeBild") && (
        <img
          src={
            process.env.REACT_APP_CMS_URL +
            getLocalized("texts", "SpielendeBild").data.attributes.url
          }
          alt="Spielende"
          className="spielendeBild"
        />
      )}
      <BlocksRenderer content={getLocalized("texts", "BewertungText")} />
      <Button
        onClick={() =>
          window.open(
            game.Bewertungslink
              ? game.Bewertungslink
              : "https://www.mitmach-krimi.de/collections/krimidinner-zuhause",
            "_blank",
          )
        }
      >
        {getLocalized("texts", "BewertungButton")}
      </Button>

      <div className="shopifyEmbed">
        <h2>{getLocalized("texts", "WeitereKrimidinner")}</h2>

        {loading && <p className="loading">Produkte werden geladen...</p>}

        {error && (
          <div className="error">
            <p>Die Produkte können derzeit nicht angezeigt werden.</p>
            <a
              href="https://www.mitmach-krimi.de/collections/krimidinner-zuhause"
              target="_blank"
              rel="noopener noreferrer"
              className="shopLink"
            >
              {getLocalized("texts", "ShopProdukte")} →
            </a>
          </div>
        )}

        {!loading && !error && products.length > 0 && (
          <div className="productsGrid">
            {products.map(
              (product) =>
                product.id != game.ProductId && (
                  <a
                    key={product.id}
                    href={`https://www.mitmach-krimi.de/products/${product.handle}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="productCard"
                  >
                    {/* <span>
                  {product.id}: {product.title}
                </span> */}
                    {product.images && product.images[0] && (
                      <img
                        src={product.images[0].src}
                        alt={product.title}
                        className="productImage"
                      />
                    )}
                    <div className="productInfo">
                      <h3 className="productTitle">{product.title}</h3>
                      {product.variants && product.variants[0] && (
                        <p className="productPrice">
                          €{parseFloat(product.variants[0].price).toFixed(2)}
                        </p>
                      )}
                    </div>
                  </a>
                ),
            )}
          </div>
        )}

        <a
          href="https://www.mitmach-krimi.de/collections/krimidinner-zuhause"
          target="_blank"
          rel="noopener noreferrer"
          className="viewAllLink"
        >
          {getLocalized("texts", "ShopProdukte")} →
        </a>
      </div>
    </div>
  );
};

export default Page;
